module.exports = __webpack_public_path__ + "chainlink-link-logo.svg?4b02bc11930246d53d859deaa960862f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/chainlink-link-logo.svg
// module id = 1143
// module chunks = 2